import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import { formatDateFromDB } from '../../../../../../../utils/FormatDate';
import MuiGrid from '../../../../../UI/MuiGrid/MuiGrid';
import MuiDialog from '../../../../../UI/MuiDialog/MuiDialog';
import ChatPreview from '../../DatailView/components/ZSGridProvider/ChatPreview';
import useHttp from '../../../../../../hooks/use-http';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../../../../shared/api/handleErrorMessage';
import { urls } from '../api/urls';

const KonverzacijeGridProvider = ({ data, isLoading, idMasineTest }) => {
  const { t } = useTranslation();
  const { getData: sendEmail } = useHttp('');
  const [openChat, setOpenChat] = useState(false);
  const [selectedDatum, setSelectedDatum] = useState(null);
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [emailRow, setEmailRow] = useState(null);
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  const handleOpenChat = (row) => {
    if (!row?.datum || !idMasineTest) return;
    setSelectedDatum(row.datum);
    setOpenChat(true);
  };

  const handleOpenEmailDialog = (row) => {
    if (!row?.datum || !idMasineTest) return;
    setEmailRow(row);
    setOpenEmailDialog(true);
  };

  const handleSendEmail = async () => {
    if (!emailRow?.datum || !idMasineTest) return;

    try {
      setIsSendingEmail(true);
      const config = {
        method: 'POST',
        url: urls.SLANJE_EMAILA_TESTIRANJA,
        data: {
          idMasine: idMasineTest,
          datum: emailRow.datum,
        },
      };
      const result = await sendEmail(config);
      if (result?.response) {
        toast.error(handleErrorMessage(result));
        return;
      }
      toast.success(t('testingEmailSentSuccessfully'));
      setOpenEmailDialog(false);
      setEmailRow(null);
    } catch (error) {
      toast.error(handleErrorMessage(error) || t('testingEmailSendError'));
      console.error('Greška pri slanju emaila testiranja:', error);
    } finally {
      setIsSendingEmail(false);
    }
  };

  const columns = [
    {
      field: 'email',
      headerName: t('email'),
      width: 90,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <IconButton
          size="small"
          color="primary"
          title={t('sendTestingEmail')}
          onClick={() => handleOpenEmailDialog(e.row)}
        >
          <EmailIcon fontSize="small" />
        </IconButton>
      ),
    },
    {
      field: 'pregled',
      headerName: t('preview', 'Pregled'),
      width: 220,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleOpenChat(e.row)}
          sx={{ textTransform: 'none', minWidth: 100 }}
        >
          {t('preview', 'Pregled')}
        </Button>
      ),
    },
    {
      field: 'datum',
      headerName: t('date'),
      width: 160,
      flex: 1,
      renderCell: (e) => <span>{formatDateFromDB(e.row.datum)}</span>,
    },
  ];

  return (
    <div style={{ height: '69vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
      <MuiDialog
        maxWidth="sm"
        open={openChat}
        title="Chat"
        content={<ChatPreview idMasine={idMasineTest} datum={selectedDatum} />}
        handleClose={() => {
          setOpenChat(false);
          setSelectedDatum(null);
        }}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="sm"
        open={openEmailDialog}
        title={t('warning')}
        text={t('confirmSendTestingEmail')}
        handleClose={() => {
          setOpenEmailDialog(false);
          setEmailRow(null);
        }}
        handleConfirm={handleSendEmail}
        deniedText={t('buttons.cancel')}
        loading={isSendingEmail}
      />
    </div>
  );
};

export default KonverzacijeGridProvider;
